/**
 * Delays a heavy task.
 * This workaround MAY help to improve INP value of WebVitals.
 *
 * @param {Function} taskFn the function of the heavy task to delay.
 */
export const delayHeavyTask = taskFn => setTimeout(taskFn, 0);
